var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8453 16.6176C30.8027 16.4373 30.7162 16.2703 30.5935 16.1315C30.4709 15.9926 30.3158 15.8862 30.1421 15.8217L22.0407 12.7828L24.1023 2.47076C24.149 2.23117 24.1165 1.98289 24.0097 1.76339C23.9029 1.5439 23.7276 1.36509 23.5102 1.25396C23.2929 1.14283 23.0453 1.10541 22.8048 1.14734C22.5644 1.18926 22.3441 1.30826 22.1771 1.48639L6.42715 18.3614C6.29923 18.4962 6.20669 18.6606 6.1578 18.8398C6.10891 19.0191 6.10519 19.2077 6.14697 19.3888C6.18876 19.5699 6.27475 19.7377 6.39725 19.8775C6.51976 20.0172 6.67497 20.1244 6.84902 20.1895L14.9532 23.2284L12.8973 33.5292C12.8506 33.7688 12.8831 34.0171 12.9899 34.2366C13.0967 34.4561 13.272 34.6349 13.4894 34.746C13.7067 34.8571 13.9543 34.8946 14.1948 34.8526C14.4352 34.8107 14.6556 34.6917 14.8225 34.5136L30.5725 17.6386C30.6981 17.5038 30.7886 17.3401 30.8362 17.1621C30.8838 16.9841 30.8869 16.7971 30.8453 16.6176ZM15.88 30.0937L17.3523 22.7278C17.405 22.4666 17.3632 22.1951 17.2345 21.9618C17.1057 21.7284 16.8983 21.5484 16.6492 21.4537L9.21855 18.6623L21.1182 5.91326L19.6473 13.2792C19.5946 13.5404 19.6364 13.8119 19.7651 14.0452C19.8939 14.2785 20.1013 14.4586 20.3504 14.5533L27.7754 17.3376L15.88 30.0937Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricity);
export default __webpack_public_path__ + "static/media/electricity.181b2da838b408f194dc7d959f220558.svg";
export { ForwardRef as ReactComponent };